import BlogFormContent from './BlogFormContent';

export default BlogFormContent;
